// Shared console-output gate for tracking logs. LogRocket always receives the event via the logger;
// the console only prints in dev builds (the logger's own env check) or when ?test=true. Set once
// during TrackingService.initialize() and read everywhere - the models can gate their logs without
// importing TrackingService, which imports them back and would be a circular dependency.
let testModeConsole = false;

const setTestModeConsole = (value) => {
    testModeConsole = value === true;
};

const getTestModeConsole = () => testModeConsole;

export { setTestModeConsole, getTestModeConsole };
